class itemHistoryController {
    /*@ngInject*/
    constructor($state, $stateParams, $translate, $scope, CommonLayoutService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.$scope = $scope;
        this.CommonLayoutService = CommonLayoutService;

        this.model = {
            itemHistoryObj: null
        };
        this.loadCompanyLogo = false;
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.model.itemHistoryObj = window.opener.w.printData;
            this.print();
        }
    };

    print() {
        setTimeout(() => {
            window.print();
        }, 1500);

        let timeId = setTimeout(() => {
            this.loadCompanyLogo = true;
            this.$scope.$apply();
            clearTimeout(timeId);
        }, 1000);
    };

    translateItemHistoryMsg = (entryType) => {
        return this.CommonLayoutService.translateItemHistoryMessage(entryType);
    };

}

export default itemHistoryController;


// WEBPACK FOOTER //
// ./client/app/components/item/print/item_history.controller.js